export default "__VITE_ASSET__sZpGaXtm__"